import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketSalesScreen() {
    return (
        <DefaultLayout>
            <MarketSales />
        </DefaultLayout>
    );
}

function MarketSales() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:market:sales:list"));

    if (!apiData) return;

    const header = t("Активные скидки");

    const headerTools = <ExportButton size="sm" />;

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Игра")}</th>
                        <th>{t("Кампания")}</th>
                        <th>{t("Дата начала")}</th>
                        <th>{t("Дата окончания")}</th>
                        <th>{t("Скидка")}</th>
                        <th>{t("Валюта")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => (
                        <tr key={`object_list${i}`}>
                            <td>
                                <Link to={url_reverse("games:prices", { game_id: o.game_id })}>
                                    {o.game.base_locale_object.name}
                                </Link>
                            </td>
                            <td>{o?.campaign && o.campaign.name}</td>
                            <td>{o.date_start}</td>
                            <td>{o.date_end}</td>
                            <td>{o.discount}</td>
                            <td>{o.currency}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}
